import React from "react";

import { Creative } from "@components/creatives";
import { LoadingSlideNoText } from "@components/title-slide-view";
import { FETCH_CREATIVE_PREVIEWS } from "@gql/creative-analytics";
import { useNorthbeamQuery } from "@hooks/http";
import {
  type FetchCreativePreviews,
  type FetchCreativePreviewsVariables,
} from "@north-beam/nb-client-side";
import { deslugify, jsonHash } from "@north-beam/nb-common";

import { type Option } from "./creatives";

interface Props {
  ad: Option;
}

export const Preview = ({ ad }: Props) => {
  const { data, loading } = useNorthbeamQuery<
    FetchCreativePreviews,
    FetchCreativePreviewsVariables
  >(FETCH_CREATIVE_PREVIEWS, {
    variables: { adKey: jsonHash(deslugify(ad.value)) },
  });

  return (
    <div className="my-5 min-h-[600px] flex flex-col">
      <h5 className="text-cosmic text-sm font-bold">{ad.label}</h5>
      {loading && (
        <div className="flex-1 flex items-center px-10">
          <LoadingSlideNoText />
        </div>
      )}
      <div>
        {data?.me.creativePreviews.previews.map((e, i) => (
          <Creative key={i} ad={e} />
        ))}
      </div>
    </div>
  );
};
